import { Toast, Tooltip } from './_bootstrap';

(function () {
	// * Tooltip initialization, remove it if not necessary
	document
		.querySelectorAll('[data-toggle="tooltip"]')
		.forEach((tooltipElement) => new Tooltip(tooltipElement));

	// * Toast initialization, remove it if not necessary
	document
		.querySelectorAll('.toast')
		.forEach((toastElement) => new Toast(toastElement));
})();



const observer = new IntersectionObserver(entries => {
    // Loop over the entries
    entries.forEach(entry => {
      // If the element is visible
      if (entry.isIntersecting) {
        // Add the animation class
        entry.target.classList.add('slide-up');
		return;
      }

	  entry.target.classList.remove('slide-up');
    });
  });
  
//observer.observe(document.querySelector('.up-selector'));

// Get multiple elements instead of a single one using "querySelectorAll"
const squares = document.querySelectorAll('.up-selector');
const squares3 = document.querySelectorAll('.field--name-field-project-description');

// Loop over the elements and add each one to the observer
squares.forEach((element) => observer.observe(element));
squares3.forEach((element) => observer.observe(element));

//
const observer2 = new IntersectionObserver(entries => {
    // Loop over the entries
    entries.forEach(entry => {
      // If the element is visible
      if (entry.isIntersecting) {
        // Add the animation class
        entry.target.classList.add('slide-left');
		return;		
      }

	  entry.target.classList.remove('slide-left');
    });
  });
  
  // Get multiple elements instead of a single one using "querySelectorAll"
  const squares2 = document.querySelectorAll('.heading');

  // Loop over the elements and add each one to the observer
  squares2.forEach((element) => observer2.observe(element));

